<ng-template [ngIf]="total > 0">
  <p>{{ 'txt_pagination_active_page_label' | translate: translationParams }}</p>
</ng-template>
<ng-template [ngIf]="!total">
  <p data-lokalise data-key="txt_pagination_no_results"></p>
</ng-template>
